import React, { Fragment, Component } from "react"
import { Formik, Form } from "formik"
import { inject, observer } from "mobx-react"
import * as Yup from "yup"
import Translate from "../../utils/Translate"
import { wordFilter } from "../../utils/Utils"
import "./GenerateIdeas.css"
import Storage from "localStorage"
import LoaderIA from "../../components/loaderIA"

const validationSchema = Yup.object().shape({
})

class GenerateIdeas extends Component {

    state = {}

    componentDidMount = () => {
        const { inspiredStore } = this.props
        inspiredStore.getValues()
    }

    copyCodeToClipboard = () => {
        const { inspiredStore } = this.props
        
        let text = inspiredStore.messages.map(a => {
            let concat = a.result + ' ';
            return concat.replace("|", '\n').replace("|#", '\n#').replace("|V", '\nV');
        })

        let newText = text.join('\n\n')

        navigator.clipboard.writeText(newText).then(function() {
        }, function(err) {
          console.error('Async: Could not copy text: ', err);
        })
    }

    getImage = (image) => {
        return image ? 'Image: ' + image : ''; 
    }

    handleSubmit = async (values, { setFieldError }) => {
        const { inspiredStore, modalStore } = this.props
        const params = {
            ...values,
        }

        const validate = Object.entries(values)
            .map(([key, value]) => {
                const newValue = wordFilter(value)
                const lengthNewValue = newValue.length > 1
                const message =
                    newValue.length > 0 &&
                    `Sorry, we can't use ${lengthNewValue ? "these words:" : "this word:"
                    } ${newValue}. ${lengthNewValue ? "Please change them." : "Please change it."
                    }`

                setFieldError(key, message)
                this.setState((prevState) => ({
                    ...prevState,
                    [key]: newValue,
                }))
                return newValue.length > 0
            })
            .some((item) => item)

        if (!validate) {
            // modalStore.addBlur();
            // modalStore.addBlurOnHeader();
            inspiredStore.getInspiration(params)
        }
    }

    handleNewIdea = () => {
        const { inspiredStore } = this.props
        inspiredStore.clearIdeaCreate()
    }

    handleChangeValue = (event, setFieldValue) => {
        const { name, value } = event.currentTarget
        const { inspiredStore } = this.props
        setFieldValue(name, value)
        inspiredStore.saveValue(name, value)
    }

    handleCloseModal = () => {
        const { inspiredStore, modalStore} = this.props
        const alertCopy = Translate.get("alertCopy", 'Make sure you have copied and pasted the ideas on a document, because when you close the window they will be gone.')
        var r = window.confirm(alertCopy);
        if (r == true) {
          inspiredStore.showModal = !inspiredStore.showModal;
          modalStore.removeBlur();
        }
    }

    renderIdea = (index, message) => {
        if (!message.idea) {
            return <div></div>
        }
        if (message.idea === 'socialpost') {
            let splitMsg = message.result.split("|")
            let headline = splitMsg[0].replace("Generated post:", "");
            let caption =  splitMsg[1];
            let visual =  splitMsg[2];
            return <div>{index + 1}.{headline}<br/><br/> {caption} <br/><br/> {visual}</div>
        }
        return <div>{index + 1}.{message.result}</div>
    }

    render() {
        const {
            parent,
            child,
            inspiredStore: { ideaCreated, messages, sending, showModal},
        } = this.props

        return (
            <div className="col-12 p-0">
                <Fragment>
                {showModal ? 
                    (<div>
                        <div className="inspired-ideas-modal">
                        {sending ? (
                                    <div className="generate-ideas-loader">
                                        <LoaderIA />
                                    </div>) :

                            (<div className="row">
                            <span onClick={this.handleCloseModal} className="inspired-ideas-close">x</span>
                            <div className="col-md-6">
                                <h1>{Translate.get("yourIdeas", "Your ideas")}</h1>
                                <p>{Translate.get("theBestWay", 'The best way to have a good idea is to have many ideas.')}</p>
                                <p>{Translate.get("testDifferent", 'Try out different attributes, and copy tweak the ones you like!')}</p>
                            </div>
                            <div className="col-md-6">
                                <div className="inspired-message">
                                    {(messages.map((message, index) => (
                                          <div>
                                            <h3 key={index} className="inspired-ideasTitle inspired-bottom">
                                               {this.renderIdea(index, message)}
                                            </h3>
                                            {message.image && <a href={message.image} target="_bank"><img src={message.image} width="100%" /></a>}
                                        </div>
                                    )))}
                                </div>
                            </div>
                            <div className="col-md-12">
                                    <button
                                        id="register"
                                        className="inspired-button inspired-ideas-button btnpadding"
                                        onClick={this.copyCodeToClipboard}
                                    >
                                        {Translate.get("copyIdeas", "Copy ideas")}
                                    </button>
                                    </div>
                            </div>)
                        }
                        </div>
                    </div>) : (<div/>)
                }
                    <Formik
                        initialValues={{
                            idea: ideaCreated.idea || Storage.getItem("idea") || "hero_content",
                            brand: ideaCreated.brand || "",
                            whatisit: ideaCreated.whatisit || "",
                            keyattributes: ideaCreated.keyattributes || "",
                            occasion: ideaCreated.occasion || "",
                            problem: ideaCreated.problem || "",
                            brainstormIdea: ideaCreated.brainstormIdea || "",
                            divergence: ideaCreated.divergence || Storage.getItem("divergence") || "low",
                            concept: ideaCreated.concept || Storage.getItem("concept") || "",
                            topic: ideaCreated.topic || Storage.getItem("topic") || "",
                            tone: ideaCreated.tone || Storage.getItem("tone") || "",
                            pillar: ideaCreated.pillar || Storage.getItem("pillar") || "",
                        }}
                        enableReinitialize={true}
                        validationSchema={validationSchema}
                        onSubmit={this.handleSubmit}
                    >
                        {({ values, errors, touched, isSubmitting, setFieldValue }) => {
                            return (
                                <Form className="text-left">
                                        <Fragment>
                                            <div className="generate-ideas-ctninput">
                                                <label htmlFor="brand" className="generate-ideas-label">
                                                    {Translate.get(
                                                        "typeOfIdea",
                                                        "What type of idea do you want?"
                                                    )}
                                                </label>
                                                <div className="select-wrapper">
                                                    <input type="hidden" name="lang" value={this.props.inspiredStore.lang} />
                                                    <select 
                                                        className="generate-ideas-select" 
                                                        name="idea" 
                                                        value={values.idea} 
                                                        onChange={(e) =>
                                                            this.handleChangeValue(e, setFieldValue)
                                                        } 
                                                        className={
                                                            errors.idea
                                                            ? "generate-ideas-input generate-ideas-error"
                                                            : "generate-ideas-input"
                                                        } 
                                                        required
                                                    >
                                                        <option value="hero_content">{Translate.get("lines", "Hero content")}</option>
                                                        <option value="headline">{Translate.get("headline", "Headlines")}</option>
                                                        <option value="naming">{Translate.get("naming", "Naming")}</option>
                                                        <option value="product">{Translate.get("product", "Product")}</option>
                                                        <option value="tagline">{Translate.get("taglines", "Taglines")}</option>
                                                        <option value="video_script">{Translate.get("video_script", "Video script")}</option>
                                                        <option value="brainstorm">{Translate.get("brainstorm", "Brainstorm")}</option>
                                                        <option value="socialpost">{Translate.get("socialpost", "Social post (beta)")}</option>
                                                    </select>
                                                    {errors.idea && touched.idea && (
                                                        <div className="generate-ideas-required">
                                                            {errors.idea}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            
                                            {values.idea === 'brainstorm' && 
                                                <div className="generate-ideas-ctninput">
                                                    <label htmlFor="brainstorm" className="generate-ideas-label">
                                                        {Translate.get(
                                                            "ideas",
                                                            "Idea"
                                                        )}
                                                    </label>
                                                    <input
                                                        type="text"
                                                        placeholder={Translate.get(
                                                            "yourIdea",
                                                            "Your idea"
                                                        )}
                                                        className={
                                                            errors.brainstormIdea
                                                                ? "generate-ideas-input generate-ideas-error"
                                                                : "generate-ideas-input"
                                                        }
                                                        onChange={(e) =>
                                                            this.handleChangeValue(e, setFieldValue)
                                                        }
                                                        value={values.brainstormIdea}
                                                        name="brainstormIdea"
                                                        maxLength="400"
                                                        required
                                                    />
                                                    {errors.brainstormIdea && touched.brainstormIdea && (
                                                        <div className="generate-ideas-required">
                                                            {errors.brainstormIdea}
                                                        </div>
                                                    )}
                                                </div>
                                            }
                                            
                                            {values.idea === 'product' && 
                                                <div className="generate-ideas-ctninput">
                                                    <label htmlFor="problem" className="generate-ideas-label">
                                                        {Translate.get(
                                                            "problem",
                                                            "Problem"
                                                        )}
                                                    </label>
                                                    <input
                                                        type="text"
                                                        placeholder={Translate.get(
                                                            "placeHolderProblem",
                                                            "What problem does the product need to solve?"
                                                        )}
                                                        className={
                                                            errors.problem
                                                                ? "generate-ideas-input generate-ideas-error"
                                                                : "generate-ideas-input"
                                                        }
                                                        onChange={(e) =>
                                                            this.handleChangeValue(e, setFieldValue)
                                                        }
                                                        value={values.problem}
                                                        name="problem"
                                                        maxLength="400"
                                                        required
                                                    />
                                                    {errors.problem && touched.problem && (
                                                        <div className="generate-ideas-required">
                                                            {errors.problem}
                                                        </div>
                                                    )}
                                                </div>
                                            }

                                            {values.idea !== 'naming' && values.idea !== 'product' && values.idea !== 'brainstorm' && 
                                                <div className="generate-ideas-ctninput">
                                                    <label htmlFor="brand" className="generate-ideas-label">
                                                        {Translate.get(
                                                            "protagonist",
                                                            "Who or what is the star of your idea?"
                                                        )}
                                                    </label>
                                                    <input
                                                        type="text"
                                                        placeholder={Translate.get(
                                                            "placeHolderProtagonist",
                                                            "e.g. Patagonia, Greenpeace, Brian Eno, etc."
                                                        )}
                                                        className={
                                                            errors.brand
                                                                ? "generate-ideas-input generate-ideas-error"
                                                                : "generate-ideas-input"
                                                        }
                                                        onChange={(e) =>
                                                            this.handleChangeValue(e, setFieldValue)
                                                        }
                                                        value={values.brand}
                                                        name="brand"
                                                        maxLength="25"
                                                        required
                                                    />
                                                    {errors.brand && touched.brand && (
                                                        <div className="generate-ideas-required">
                                                            {errors.brand}
                                                        </div>
                                                    )}
                                                </div>
                                            }

                                            {values.idea !== 'product' && values.idea !== 'brainstorm' && values.idea !== 'tagline' && values.idea !== 'naming' && values.idea !== 'headline' && values.idea !== 'video_script' && values.idea !== 'hero_content' &&
                                                <div className="generate-ideas-ctninput">
                                                    <label htmlFor="tone" className="generate-ideas-label">
                                                        {Translate.get(
                                                            "tone",
                                                            "What is their tone of voice?"
                                                        )}
                                                    </label>
                                                    <input
                                                        type="text"
                                                        placeholder={Translate.get(
                                                            "placeHolderTone",
                                                            "e.g. business-like, playful, etc."
                                                        )}
                                                        className={
                                                            errors.tone
                                                                ? "generate-ideas-input generate-ideas-error"
                                                                : "generate-ideas-input"
                                                        }
                                                        onChange={(e) =>
                                                            this.handleChangeValue(e, setFieldValue)
                                                        }
                                                        value={values.tone}
                                                        name="tone"
                                                        maxLength="25"
                                                        required
                                                    />
                                                    {errors.tone && touched.tone && (
                                                        <div className="generate-ideas-required">
                                                            {errors.tone}
                                                        </div>
                                                    )}
                                                </div>
                                            }

                                            {values.idea !== 'product' && values.idea !== 'brainstorm' && values.idea != 'socialpost' &&
                                                <div className="generate-ideas-ctninput">
                                                    <label htmlFor="whatisit" className="generate-ideas-label">
                                                        {Translate.get("whatisit", "What are they?")}
                                                    </label>
                                                    <input
                                                        type="text"
                                                        placeholder={Translate.get(
                                                            "placeholderWhatIsIt",
                                                            "e.g. Clothing, NGO, artist, etc."
                                                        )}
                                                        className={
                                                            errors.whatisit
                                                                ? "generate-ideas-input generate-ideas-error"
                                                                : "generate-ideas-input"
                                                        }
                                                        onChange={(e) =>
                                                            this.handleChangeValue(e, setFieldValue)
                                                        }
                                                        value={values.whatisit}
                                                        name="whatisit"
                                                        maxLength="50"
                                                    />
                                                    {errors.whatisit && touched.whatisit && (
                                                        <div className="generate-ideas-required">
                                                            {errors.whatisit}
                                                        </div>
                                                    )}
                                                </div>
                                            }

                                            {values.idea !== 'product' && values.idea !== 'brainstorm' &&
                                                <div className="generate-ideas-ctninput">
                                                    <label
                                                        htmlFor="keyattributes"
                                                        className="generate-ideas-label"
                                                    >
                                                        {Translate.get(
                                                            "keyattributes",
                                                            "What is special about them?"
                                                        )}
                                                    </label>
                                                    <input
                                                        placeholder=
                                                        {Translate.get(
                                                            "placeholderAttributes",
                                                            "e.g. Design, technology, societal role, etc."
                                                        )}
                                                        type="text"
                                                        className={
                                                            errors.keyattributes
                                                                ? "generate-ideas-input generate-ideas-error"
                                                                : "generate-ideas-input"
                                                        }
                                                        onChange={(e) =>
                                                            this.handleChangeValue(e, setFieldValue)
                                                        }
                                                        value={values.keyattributes}
                                                        name="keyattributes"
                                                        maxLength="75"
                                                    />
                                                    {errors.keyattributes && touched.keyattributes && (
                                                        <div className="generate-ideas-required">
                                                            {errors.keyattributes}
                                                        </div>
                                                    )}
                                                </div>  
                                            }

                                            {values.idea === 'socialpost' &&
                                                <div>
                                                    <div className="generate-ideas-ctninput">
                                                        <label
                                                            htmlFor="concept"
                                                            className="generate-ideas-label"
                                                        >
                                                            {Translate.get(
                                                                "concept",
                                                                "What is the campaign concept?"
                                                            )}
                                                        </label>
                                                        <input
                                                            placeholder=
                                                            {Translate.get(
                                                                "placeholderConcept",
                                                                "The brand's big idea or umbrella concept"
                                                            )}
                                                            type="text"
                                                            className={
                                                                errors.concept
                                                                    ? "generate-ideas-input generate-ideas-error"
                                                                    : "generate-ideas-input"
                                                            }
                                                            onChange={(e) =>
                                                                this.handleChangeValue(e, setFieldValue)
                                                            }
                                                            value={values.concept}
                                                            name="concept"
                                                            maxLength="75"
                                                        />
                                                        {errors.concept && touched.concept && (
                                                            <div className="generate-ideas-required">
                                                                {errors.concept}
                                                            </div>
                                                        )}
                                                    </div>

                                                    <div className="generate-ideas-ctninput">
                                                        <label
                                                            htmlFor="pillar"
                                                            className="generate-ideas-label"
                                                        >
                                                            {Translate.get(
                                                                "pillar",
                                                                "What is the communication pillar?"
                                                            )}
                                                        </label>
                                                        <input
                                                            placeholder=
                                                            {Translate.get(
                                                                "placeholderPillar",
                                                                "The pillar this post belongs to"
                                                            )}
                                                            type="text"
                                                            className={
                                                                errors.pillar
                                                                    ? "generate-ideas-input generate-ideas-error"
                                                                    : "generate-ideas-input"
                                                            }
                                                            onChange={(e) =>
                                                                this.handleChangeValue(e, setFieldValue)
                                                            }
                                                            value={values.pillar}
                                                            name="pillar"
                                                            maxLength="75"
                                                        />
                                                        {errors.pillar && touched.pillar && (
                                                            <div className="generate-ideas-required">
                                                                {errors.pillar}
                                                            </div>
                                                        )}
                                                    </div>

                                                    <div className="generate-ideas-ctninput">
                                                        <label
                                                            htmlFor="topic"
                                                            className="generate-ideas-label"
                                                        >
                                                            {Translate.get(
                                                                "topic",
                                                                "What is the topic?"
                                                            )}
                                                        </label>
                                                        <input
                                                            placeholder=
                                                            {Translate.get(
                                                                "placeholderTopic",
                                                                "e.g. seasonality, trending topic, etc."
                                                            )}
                                                            type="text"
                                                            className={
                                                                errors.topic
                                                                    ? "generate-ideas-input generate-ideas-error"
                                                                    : "generate-ideas-input"
                                                            }
                                                            onChange={(e) =>
                                                                this.handleChangeValue(e, setFieldValue)
                                                            }
                                                            value={values.topic}
                                                            name="topic"
                                                            maxLength="75"
                                                        />
                                                        {errors.topic && touched.topic && (
                                                            <div className="generate-ideas-required">
                                                                {errors.topic}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            }

                                            {values.idea !== 'product' && values.idea !== 'brainstorm' && values.idea !== 'tagline' && values.idea !== 'naming' && values.idea !== 'socialpost' && 
                                                <div className="generate-ideas-ctninput">
                                                    <label htmlFor="occasion" className="generate-ideas-label">
                                                        {Translate.get(
                                                            "occasion",
                                                            "What's the occasion? (optional)"
                                                        )}
                                                    </label>
                                                    <input
                                                        placeholder={Translate.get(
                                                            "placeholderOcassion",
                                                            "e.g. Launch, promotion, tour, etc."
                                                        )}
                                                        type="text"
                                                        className={
                                                            errors.occasion
                                                                ? "generate-ideas-input generate-ideas-error"
                                                                : "generate-ideas-input"
                                                        }
                                                        onChange={(e) =>
                                                            this.handleChangeValue(e, setFieldValue)
                                                        }
                                                        value={values.occasion}
                                                        name="occasion"
                                                        maxLength="50"
                                                    />
                                                    {errors.occasion && touched.occasion && (
                                                        <div className="generate-ideas-required">
                                                            {errors.occasion}
                                                        </div>
                                                    )}
                                                </div>
                                            }
                                            
                                            {values.idea !== 'product' && values.idea !== 'brainstorm' && 
                                                <div className="generate-ideas-ctninput">
                                                    <label htmlFor="divergence" className="generate-ideas-label">
                                                        {Translate.get(
                                                            "howUnexpected",
                                                            "How unexpected would you like your ideas to be?"
                                                        )}
                                                    </label>
                                                    <div className="select-wrapper">
                                                        <select 
                                                            className="generate-ideas-select" 
                                                            name="divergence" 
                                                            value={values.divergence} 
                                                            onChange={(e) =>
                                                                this.handleChangeValue(e, setFieldValue)
                                                            } 
                                                            className={
                                                                errors.divergence
                                                                ? "generate-ideas-input generate-ideas-error"
                                                                : "generate-ideas-input"
                                                            } 
                                                            required
                                                        >
                                                            <option value="low">{Translate.get("aLittleBit", "A little bit")}</option>
                                                            <option value="medium">{Translate.get("quite", "Quite")}</option>
                                                            <option value="high">{Translate.get("very", "Very")}</option>
                                                        </select>
                                                        {errors.divergence && touched.divergence && (
                                                            <div className="generate-ideas-required">
                                                                {errors.divergence}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            }

                                            {!sending && (<button
                                                id="register"
                                                type="submit"
                                                disabled={isSubmitting}
                                                className="generate-ideas-button"
                                            >
                                                {Translate.get("go", "Generate ideas!")}
                                            </button>)}
                                        </Fragment>
                                </Form>
                            )
                        }}
                    </Formik>
                </Fragment>
            </div>
        )
    }
}
export default inject("inspiredStore", "modalStore")(observer(GenerateIdeas))



// WEBPACK FOOTER //
// ./src/components/detail/GenerateIdeasForm.jsx